import { FormItem, FormItemProps } from 'components/Form/FormItem';
import { GasDeviceCategory } from '@enmon/commons/lib/shared/meter';
import { FormattedMessage } from 'react-intl';
import { Commodity } from '@enmon/commons';
import { GasMeterDetailField } from '../constants';
import { MeterDetails as messages } from '../../messages';
import { OrientationSelect } from '../../../../Select/meter_details/Orientation';
import { GSizeSelect } from '../../../../Select/meter_details/gas/GSize';
import { DiameterNominalSelect } from '../../../../Select/meter_details/DiameterNominal';
import { LayLengthSelect } from '../../../../Select/meter_details/LayLength';
import { PMaxSelect } from '../../../../Select/meter_details/gas/PMax';
import { QMinSelect } from '../../../../Select/meter_details/gas/QMin';
import { QMaxSelect } from '../../../../Select/meter_details/gas/QMax';
import { GasMeasurementCategorySelect } from '../../../../Select/meter_details/gas/GasMeasurementCategory';
import { GasDeviceCategorySelect } from '../../../../Select/meter_details/gas/GasDeviceCategory';

export interface AdditionalGasDetails {
  deviceCategory?: GasDeviceCategory | null;
}

export const getGasDetailFormItem = (
  field: GasMeterDetailField,
  formItemProps: FormItemProps,
  { deviceCategory }: AdditionalGasDetails,
) => {
  switch (field) {
    case GasMeterDetailField.DeviceCategory:
      return (
        <FormItem
          getValueFromEvent={(value?: string) => value ?? null}
          label={<FormattedMessage {...messages.deviceType} />}
          name={['detail', 'deviceCategory']}
          {...formItemProps}
        >
          <GasDeviceCategorySelect />
        </FormItem>
      );
    case GasMeterDetailField.MeasurementCategory:
      return (
        <FormItem
          label={<FormattedMessage {...messages.measurementCategory} />}
          name={['detail', 'measurementCategory']}
          tooltip={<FormattedMessage {...messages.gasMeasurementCategoryTooltip} />}
          {...formItemProps}
        >
          <GasMeasurementCategorySelect />
        </FormItem>
      );
    case GasMeterDetailField.Orientation:
      return (
        <FormItem
          label={<FormattedMessage {...messages.orientation} />}
          name={['detail', 'orientation']}
          {...formItemProps}
        >
          <OrientationSelect />
        </FormItem>
      );
    case GasMeterDetailField.GSize:
      return (
        <FormItem
          label={<FormattedMessage {...messages.gSize} />}
          name={['detail', 'gSize']}
          tooltip={<FormattedMessage {...messages.gSizeTooltip} />}
          {...formItemProps}
        >
          <GSizeSelect />
        </FormItem>
      );
    case GasMeterDetailField.DiameterNominal:
      return (
        <FormItem
          label={<FormattedMessage {...messages.diameterDimensionNominal} />}
          name={['detail', 'diameterNominal']}
          tooltip={<FormattedMessage {...messages.diameterDimensionNominalTooltip} />}
          {...formItemProps}
        >
          <DiameterNominalSelect />
        </FormItem>
      );
    case GasMeterDetailField.LayLength:
      return (
        <FormItem
          label={<FormattedMessage {...messages.layLength} />}
          name={['detail', 'layLength']}
          tooltip={<FormattedMessage {...messages.layLengthTooltip} />}
          {...formItemProps}
        >
          <LayLengthSelect commodity={Commodity.NaturalGas} deviceCategory={deviceCategory} />
        </FormItem>
      );
    case GasMeterDetailField.PMax:
      return (
        <FormItem
          label="Pmax"
          name={['detail', 'pMax']}
          tooltip={<FormattedMessage {...messages.pMaxTooltip} />}
          {...formItemProps}
        >
          <PMaxSelect />
        </FormItem>
      );
    case GasMeterDetailField.QMin:
      return (
        <FormItem
          label="Qmin"
          name={['detail', 'qMin']}
          tooltip={<FormattedMessage {...messages.qMinTooltip} />}
          {...formItemProps}
        >
          <QMinSelect />
        </FormItem>
      );
    case GasMeterDetailField.QMax:
      return (
        <FormItem
          label="Qmax"
          name={['detail', 'qMax']}
          // It is same tooltip as for qMin
          tooltip={<FormattedMessage {...messages.qMinTooltip} />}
          {...formItemProps}
        >
          <QMaxSelect />
        </FormItem>
      );
    default:
      return null;
  }
};
